import { Container, Graphics, Point, Text, TextStyle } from 'pixi.js';
import * as PIXI from 'pixi.js';
import { rgb } from './common';
import { Int8Reader } from './heartRate';

function makePos(height: number, lowValue: number, highValue: number, rawValue: number) {
  if (rawValue < lowValue) {
    return height;
  }
  if (rawValue > highValue) {
    return 0;
  }

  const mvPerY = height / (highValue - lowValue);
  const y = height - mvPerY * rawValue;
  return y;
}

function minMax(prev: number, current: number) {
  if (Math.abs(prev) < Math.abs(current)) {
    return current;
  }
  return prev;
}

function getData(reader: Int8Reader, ave: number) {
  if (ave === 1) {
    return reader.next();
  }
  const ret = reader.chunk(ave);
  return ret.reduce(minMax, 0);
}

export class PixiChChart {
  private container: Container;
  private mask: Graphics;
  private line: Graphics;
  private text: PIXI.Text;

  constructor(
    private width: number,
    private height: number,
    private lineColor: number,
    private name: string,
  ) {
    this.container = new Container();
    this.line = new Graphics();
    this.mask = new Graphics();

    const style = new TextStyle({
      fontFamily: 'Arial',
      fill: [rgb(99, 0, 255)],
      fontSize: 12,
    });
    this.text = new PIXI.Text(this.name, style);
    this.text.position = new PIXI.Point(10, this.height / 2 - 6);
    this.container.addChild(this.text);

    // this.line.mask = this.mask;
    this.container.addChild(this.line);
    this.line.lineStyle(1, this.lineColor);

    this.mask.beginFill(0x505050)
      .drawRect(0, 0, this.width, this.height)
      .endFill();
    this.mask.position = new Point(-this.width, 0);
    // this.container.addChild(this.mask);
    // this.mask.cacheAsBitmap = true;
    this.container.addChild(this.mask);
    this.container.mask = this.mask;
    this.mask.width = 50;
    this.mask.position.x = 0;
  }

  public draw(
    reader: Int8Reader,
    length: number,
    aveCount: number,
    low: number,
    high: number,
  ) {
    this.line.cacheAsBitmap = false;
    this.line.clear();
    this.line.lineStyle(1, this.lineColor);

    this.line.moveTo(50, this.height / 2);

    for (let i = 0; i < length; i += 1) {
      if (reader.isEnd()) {
        console.log(`is end ${i}`);
        break;
      }
      const v = getData(reader, aveCount);
      const val = makePos(this.height, low, high, v);
      this.line.lineTo(i + 50, val);
    }

    this.line.cacheAsBitmap = true;
    // this.mask.moveTo(-this.width, 0);
  }

  public tick(current: number, max: number) {
    if (current > max) {
      if (this.mask.width === this.width + 50) {
        return;
      }
      this.mask.width = this.width + 50;
      return;
    }
    const per = current / max;
    const pos = per * this.width;
    this.mask.width = pos + 50;
  }

  public getC() {
    return this.container;
  }
}

export default {
  PixiChChart,
};
